import Store from "../Store/Store";
import { ContractInterface } from "../Entity/Entities/Contract/ContractInterface";
import { CompanyInterface } from "../Entity/Entities/Company/CompanyInterface";
import { PersonInterface } from "../Entity/Entities/Person/PersonInterface";

export interface SearchResponseInterface {
  name: string;
  image: string;
  url: string;
  updatedAt: Date;
  instance: any;
}

class Search {

  protected text: string = "";

  public search = (text: string, shouldFilter: boolean, searchParameter: string): Promise<any> => {
    /*
    |  @todo connect to Elastic Search
    |  We implemented it on the frontend because ElasticSearch code on backend is really terrible.
    |  This is something we wrapped quickly to support a fake-elastic search.
    */
    return new Promise(accept => {
      this.text = text;

      if (!shouldFilter && text.length === 0) {
        return accept([]);
      }

      let entities;

      if (shouldFilter) {
        entities = [
          ...this.filterUnits(),
          ...this.filterProperties(),
          ...this.filterContracts(),
          ...this.filterCompanies(shouldFilter)
        ];

        if (searchParameter === "contactsSearch") {
          entities = [
            ...this.filterPersons(),
            ...this.filterCompanies()
          ];
        }

        if (searchParameter === "objectForTaskSearch") {
          entities = [
            ...this.filterUnits(),
            ...this.filterProperties(),
          ];
        }

        if (searchParameter === "objectForActivitySearch") {
          entities = [
            ...this.filterUnits()
          ];
        }

        if (searchParameter === "objectForNoteSearch") {
          entities = [
            ...this.filterUnits(),
            ...this.filterProperties(),
            ...this.filterContracts(),
            ...this.filterPersons(),
            ...this.filterCompanies()
          ];
        }

        if (searchParameter === "objectForChargeSearch") {
          entities = [
            ...this.filterUnits(),
            // ...this.filterProperties(),
            ...this.filterContracts(shouldFilter),
            ...this.filterCompanies(shouldFilter)
          ];
        }

        if (searchParameter === "objectForChargeCoachSearch") {
          entities = [
            ...this.filterUnits(),
            ...this.filterProperties(),
            ...this.filterContracts(shouldFilter)
          ];
        }
      } else {
        entities = [
          ...this.filterUnits(),
          // ...this.filterProperties(),
          ...this.filterContracts(),
          ...this.filterPersons(),
          ...this.filterCompanies()
        ];
      }

      return accept(entities);
    });
  }

  // solution to have a possibility to find entities with special symbols
  public deUmlaut(value){
    if (!value) {
      return "";
    }

    value = value.toLowerCase();
    value = value.replace(/ä/g, 'a');
    value = value.replace(/ö/g, 'o');
    value = value.replace(/ü/g, 'u');
    value = value.replace(/ß/g, 'ss');
    value = value.replace(/ /g, '-');
    value = value.replace(/\./g, '');
    value = value.replace(/,/g, '');
    value = value.replace(/\(/g, '');
    value = value.replace(/\)/g, '');

    return value;
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public propertyComparer = (a, b) => {
    return this.comparer(a?.address?.locality, b?.address?.locality) ||
      this.comparer(a?.address?.route, b?.address?.route) ||
        this.comparer(a?.address?.formattedAddress, b?.address?.formattedAddress);
  }

  public unitComparer = (a, b) => {
    return this.comparer(a?.property?.address?.locality, b?.property?.address?.locality) ||
      this.comparer(a?.property?.address?.route, b?.property?.address?.route) ||
        this.comparer(a?.property?.address?.formattedAddress, b?.property?.address?.formattedAddress) ||
          this.comparer(a?.unitNumber, b?.unitNumber);
  }

  public filterPersons(): SearchResponseInterface[] {
    return Store.getConfigurator().getState().app.persons
      .filter(person => !!person && !person.removed
        // && !person.isAdmin()
      // && !person.isUser()
      )
      .sort((person1: PersonInterface, person2: PersonInterface) => {
        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return 1;
        }

        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return -1;
        }

        return  0;
      })
      .reduce((arr, person) => {
        // Search display name
        if (person.displayName && person.displayName.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            person: person
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(person.displayName).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              person: person
            });
            return arr;
          } else {
            // try to change the positions of the words to have a possibility find person with
            // FirstName LastName or LastName FirstName
            let stringArr = this.text.toLocaleLowerCase().split(" ");
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!(person.displayName && (person.displayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {
              arr.push({
                person: person
              });
              return arr;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(person.displayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                arr.push({
                  person: person
                });
                return arr;
              }
            }
          }
        }

        // Search email
        if (person.email && person.email.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            person: person
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(person.email).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              person: person
            });
            return arr;
          }
        }

        // Search phone number 1
        if (person.phone1 && person.phone1.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            person: person
          });
          return arr;
        }

        // Search phone number 2
        if (person.phone2 && person.phone2.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            person: person
          });
          return arr;
        }

        return arr;
      }, [])
      .map(res => {
        if (!res) {
          return;
        }

        return {
          name: res.person && res.person.displayName,
          image: res.person && res.person.avatar,
          updatedAt: res.person && res.person.updatedAt,
          url: `/app/person/update/${res.person && res.person.id}`,
          instance: res.person
        };
      });
  }

  public filterCompanies(shouldFilter?): SearchResponseInterface[] {
    let companies = [...Store.getConfigurator().getState().app.companies]
                        .filter(company => !!company && company.removed === false)
                        .filter(company => {
                          // should show only owners when shouldFilter === true (for object lookup field)
                          if (shouldFilter) {
                            return company.isOwner || company.isAgency;
                          }

                          return true;
                        })
                        .sort((company1: CompanyInterface, company2: CompanyInterface) => {
                          if (company1.name.toLowerCase() > company2.name.toLowerCase()) {
                            return 1;
                          }

                          if (company1.name.toLowerCase() < company2.name.toLowerCase()) {
                            return -1;
                          }

                          return  0;
                        });

    if (shouldFilter) {
      companies = [...companies];
    }

    return [...companies]
      .reduce((arr, company) => {
        // Search display name
        if (company.displayName && company.displayName.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            company: company
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(company.displayName).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              company: company
            });
            return arr;
          } else {
            // try to change word positions
            let stringArr = this.text.toLocaleLowerCase().split(" ");
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!(company.displayName && (company.displayName.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {
              arr.push({
                company: company
              });
              return arr;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(company.displayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                arr.push({
                  company: company
                });
                return arr;
              }
            }
          }
        }

        // Search email
        if (company.email && company.email.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            company: company
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(company.email).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              company: company
            });
            return arr;
          }
        }

        return arr;
      }, [])
      .map(res => {
        if (!res) {
          return;
        }

        return {
          name: res.company && res.company.displayName,
          image: res.company && res.company.avatar,
          updatedAt: res.company && res.company.updatedAt,
          url: res?.company?.isOwner ?
               `/app/owner/update/${res?.company?.id}` :
               res?.company?.isAgency ?
                 `/app/agency/update/${res?.company?.id}` :
                 `/app/company/update/${res?.company?.id}`,
          instance: res.company
        };
      });
  }

  public filterProperties(): SearchResponseInterface[] {
    return Object.keys(Store.getConfigurator().getState().properties?.byId || {}).map((id) => Store.getConfigurator().getState().properties.byId[id])
      .filter(property => !!property && !property.removed && (property?.units?.length > 1))
      .sort(this.propertyComparer)
      .reduce((arr, property) => {
        if (property.address && property.address.route
              && property.address.route.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            property: property
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (property.address && property.address.route
                && this.deUmlaut(property.address.route).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              property: property
            });
            return arr;
          }
        }

        if (property.address && property.address.streetNumber
              && property.address.streetNumber.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            property: property
          });
          return arr;
        }

        // Search address
        if (property.address
              && property.address.formattedAddress.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            property: property
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(property.address.formattedAddress).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              property: property
            });
            return arr;
          }
        }

        return arr;
      }, [])
      .map(res => {
        if (!res) {
          return;
        }

        return {
          name: res.property && res.property.address && res.property.address.formattedAddress,
          image: res.property && res.property.avatar,
          updatedAt: res.property && res.property.updatedAt,
          url: `/app/property/update/${res.property && res.property.id}`,
          instance: res.property
        };
      });
  }

  public filterUnits(): SearchResponseInterface[] {
    return Object.keys(Store.getConfigurator().getState().units?.byId || {}).map((id) => Store.getConfigurator().getState().units.byId[id])
      .filter(unit => !!unit && !unit.removed)
      .sort(this.unitComparer)
      .reduce((arr, unit) => {
        // Search address
        if (unit.property
              && unit.property.address
              && unit.property.address.formattedAddress
              && unit.property.address.formattedAddress.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            unit: unit
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(unit.property
                && unit.property.address
                && unit.property.address.formattedAddress).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              unit: unit
            });
            return arr;
          }
        }

        // Search unit number
        if (unit.unitNumber && unit.unitNumber.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            unit: unit
          });
          return arr;
        }

        // Search the name of the Tenant of the unit.
        const contract = unit.getActiveContract();

        if (!!contract) {
          // Search display name
          if (contract.occupant && contract.occupant.displayName.toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              unit: unit
            });
            return arr;
          } else {
            // try to search again after deUmlaut
            if (this.deUmlaut(contract.occupant && contract.occupant.displayName).toLowerCase().includes(this.text.toLowerCase()) === true) {
              arr.push({
                unit: unit
              });
              return arr;
            }
          }
        }
        //Search Unit shortDisplayName

        if (unit.shortDisplayName && unit.shortDisplayName.toLowerCase().includes(this.text.toLowerCase()) === true){
          arr.push({
            unit: unit
          });
        } else {
          if (this.deUmlaut(unit.shortDisplayName && unit.shortDisplayName).toLowerCase().includes(this.text.toLowerCase()) === true){
            arr.push({
              unit: unit
            });
            return arr;
          }
        }

        return arr;
      }, [])
      .map(res => {
        if (!res) {
          return;
        }

        return {
          name: res.unit && res.unit.displayName,
          image: res.unit && res.unit.avatar,
          updatedAt: res.unit && res.unit.updatedAt,
          url: `/app/unit/update/${res.unit && res.unit.id}`,
          instance: res.unit
        };
      });
  }

  public filterContracts = (shouldFilter?): SearchResponseInterface[] => {
    return Store.getConfigurator().getState().app.contracts
      .filter(contract => !!contract && !contract.removed && !contract.isClosed)
      .filter(contract => {
        if (shouldFilter) {
          return !contract.isConcept
        }

        return true;
      })
      .sort((contract1: ContractInterface, contract2: ContractInterface) => {
        if (contract1.firstDate < contract2.firstDate) {
          return 1;
        }

        if (contract1.firstDate > contract2.firstDate) {
          return -1;
        }

        return  0;
      })
      .reduce((arr, contract) => {
        // Search by address
        if ( contract.unit
              && contract.unit.property
              && contract.unit.property.address
              && contract.unit.property.address.formattedAddress
              && contract.unit.property.address.formattedAddress.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(contract.unit
                && contract.unit.property
                && contract.unit.property.address
                && contract.unit.property.address.formattedAddress).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              contract: contract
            });
            return arr;
          }
        }

        // Search by unitNumber
        if (contract.unit && contract.unit.unitNumber && contract.unit.unitNumber.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        }

        // Search by person displayname
        if (contract?.tenantDisplayName?.toLowerCase().includes(this.text.toLowerCase()) === true) {
          arr.push({
            contract: contract
          });
          return arr;
        } else {
          // try to search again after deUmlaut
          if (this.deUmlaut(contract?.tenantDisplayName).toLowerCase().includes(this.text.toLowerCase()) === true) {
            arr.push({
              contract: contract
            });
            return arr;
          } else {
            // try to change word positions
            let stringArr = this.text.toLocaleLowerCase().split(" ");
            stringArr = stringArr.map((string, index) => {
              if (index !== stringArr.length - 1) {
                return string + " ";
              }

              else {
                return string;
              };
            });

            let isIncluded = true;

            stringArr.forEach(string => {
              if (!((contract?.tenantDisplayName?.toLowerCase() + " ").includes(string))) {
                isIncluded = false;
              }
            })

            if (isIncluded) {
              arr.push({
                contract: contract
              });
              return arr;
            } else {
              let isIncluded = true;

              stringArr.forEach(string => {
                if (!((this.deUmlaut(contract?.tenantDisplayName).toLowerCase() + " ").includes(string))) {
                  isIncluded = false;
                }
              })

              if (isIncluded) {
                arr.push({
                  contract: contract
                });
                return arr;
              }
            }
          }
        }

        return arr;
      }, [])
      .map(res => {
        if (!res) {
          return;
        }

        return {
          name: `${res.contract?.tenantDisplayName}, ${res.contract && res.contract.unit && res.contract.unit.displayName}`,
          image: res.contract && res.contract.avatar,
          updatedAt: res.contract && res.contract.updatedAt,
          url: `/app/contract/update/${res.contract && res.contract.id}/0`,
          instance: res.contract
        };
      });
  }
}

export default new Search();
